//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationCardHeader",
  props: {
    invisibleTile: {
      type: Boolean,
      default: false
    }
  }
});